import { errorMessage } from './api/errors.ts';

export function ErrorState({ error }: { error: unknown }) {
  return (
    <p role="alert" className="m-0 text-sm text-destructive">
      {errorMessage(error)}
    </p>
  );
}
